import { UserFormProps } from '../EditUsers.types';

export const UserFormValues: UserFormProps = {
  id: undefined,
  firstName: '',
  lastName: '',
  email: '',
};
